/* ============================================================================
   ANNTURE · DIGITAL FLAGSHIP — script.js  (lightweight vanilla JS)
   ========================================================================== */
(function () {
  "use strict";
  var doc = document, body = doc.body;
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var fine = window.matchMedia("(hover: hover) and (pointer: fine)").matches;

  /* ---- preloader: lift the veil once the page is ready ---- */
  function reveal() { body.classList.add("is-loaded"); }
  window.addEventListener("load", function () { setTimeout(reveal, 380); });
  setTimeout(reveal, 2200); // fallback so we never trap the visitor

  /* ---- nav: transparent over hero → solid past it, hide on scroll-down ---- */
  var nav = doc.querySelector("[data-nav]");
  var hero = doc.querySelector(".hero");
  if (nav && hero && "IntersectionObserver" in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        nav.classList.toggle("nav--solid", e.intersectionRatio < 0.35);
      });
    }, { threshold: [0, 0.1, 0.25, 0.35, 0.5, 0.75] }).observe(hero);
  } else if (nav) {
    nav.classList.add("nav--solid");
  }
  // refined hide-on-down / show-on-up (only once past the hero)
  var lastY = window.pageYOffset, ticking = false;
  function onScroll() {
    var y = window.pageYOffset;
    if (nav && y > window.innerHeight) {
      if (y > lastY + 8) nav.classList.add("nav--hidden");
      else if (y < lastY - 8) nav.classList.remove("nav--hidden");
    } else if (nav) {
      nav.classList.remove("nav--hidden");
    }
    lastY = y;
    updateFloat();
    ticking = false;
  }
  window.addEventListener("scroll", function () {
    if (!ticking) { window.requestAnimationFrame(onScroll); ticking = true; }
  }, { passive: true });

  /* ---- mobile menu ---- */
  var menu = doc.querySelector("[data-menu]");
  var openBtn = doc.querySelector("[data-menu-open]");
  var closeBtn = doc.querySelector("[data-menu-close]");
  function setMenu(open) {
    if (!menu) return;
    menu.classList.toggle("is-open", open);
    if (openBtn) openBtn.setAttribute("aria-expanded", String(open));
    body.style.overflow = open ? "hidden" : "";
  }
  if (openBtn) openBtn.addEventListener("click", function () { setMenu(true); });
  if (closeBtn) closeBtn.addEventListener("click", function () { setMenu(false); });
  doc.querySelectorAll("[data-menu-link]").forEach(function (a) {
    a.addEventListener("click", function () { setMenu(false); });
  });
  doc.addEventListener("keydown", function (e) { if (e.key === "Escape") setMenu(false); });

  /* ---- search overlay ---- */
  var search = doc.querySelector("[data-search]");
  var searchInput = doc.querySelector("[data-search-input]");
  function setSearch(open) {
    if (!search) return;
    search.classList.toggle("is-open", open);
    search.setAttribute("aria-hidden", String(!open));
    body.style.overflow = open ? "hidden" : "";
    if (open && searchInput) { setTimeout(function () { searchInput.focus(); }, 80); }
  }
  doc.querySelectorAll("[data-search-open]").forEach(function (b) {
    b.addEventListener("click", function () { setMenu(false); setSearch(true); });
  });
  var searchClose = doc.querySelector("[data-search-close]");
  if (searchClose) searchClose.addEventListener("click", function () { setSearch(false); });
  if (search) search.addEventListener("click", function (e) { if (e.target === search) setSearch(false); });
  doc.addEventListener("keydown", function (e) { if (e.key === "Escape") setSearch(false); });

  /* ---- scroll reveals (incl. masked manifesto lines) ---- */
  var revealEls = doc.querySelectorAll("[data-reveal]");
  if (reduce || !("IntersectionObserver" in window)) {
    revealEls.forEach(function (el) { el.classList.add("is-in"); });
  } else {
    var ro = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("is-in"); ro.unobserve(e.target); }
      });
    }, { threshold: 0.16, rootMargin: "0px 0px -8% 0px" });
    revealEls.forEach(function (el) { ro.observe(el); });
  }

  /* ---- subtle float parallax on featured objects ---- */
  var floaters = [];
  if (fine && !reduce) {
    doc.querySelectorAll("[data-float]").forEach(function (el) {
      var img = el.querySelector("img");
      if (img) floaters.push(img);
    });
  }
  function updateFloat() {
    if (!floaters.length) return;
    var vh = window.innerHeight;
    for (var i = 0; i < floaters.length; i++) {
      var img = floaters[i];
      var r = img.getBoundingClientRect();
      if (r.bottom < -200 || r.top > vh + 200) continue;
      var progress = (r.top + r.height / 2 - vh / 2) / vh; // -1..1 through viewport
      img.style.setProperty("--py", (progress * -18).toFixed(2) + "px");
    }
  }
  updateFloat();

  /* ---- responsive hero + atelier video loaders ----
     Empty in this mockup → the cinematic CSS placeholders show.
     To go live, set the paths; the hero swaps desktop/mobile via matchMedia. */
  var HERO_SOURCES = { desktop: "", mobile: "" };   // assets/video/hero-desktop.mp4 / hero-mobile.mp4
  var ATELIER_SOURCES = { desktop: "" };            // assets/video/atelier-filing.mp4

  function activate(video, src) {
    if (!video || !src) return;
    video.setAttribute("src", src);
    video.load();
    var p = video.play();
    if (p && p.catch) p.catch(function () {});
    video.addEventListener("loadeddata", function () { video.classList.add("is-ready"); }, { once: true });
  }
  var heroVideo = doc.querySelector("[data-hero-video]");
  if (heroVideo) {
    // Sources are already in the HTML (preload=auto) — the browser fetches during parse.
    // Reveal on the earliest of these events; hard fallback so it never stays hidden.
    var revealHero = function () { heroVideo.classList.add("is-ready"); };
    if (heroVideo.readyState >= 2) revealHero();
    else ["loadeddata", "canplay", "playing"].forEach(function (ev) { heroVideo.addEventListener(ev, revealHero, { once: true }); });
    setTimeout(revealHero, 1000);
    var hp = heroVideo.play(); if (hp && hp.catch) hp.catch(function () {});
  }
  activate(doc.querySelector("[data-atelier-video]"), ATELIER_SOURCES.desktop);

  /* ---- footer year ---- */
  var yr = doc.querySelector("[data-year]");
  if (yr) yr.textContent = new Date().getFullYear();
})();

/* ============================================================================
   ANNTURE · cart drawer (AJAX) + product page
   ========================================================================== */
(function () {
  "use strict";
  var doc = document;
  function money(cents) {
    var c = (cents || 0) / 100;
    return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", minimumFractionDigits: c % 1 === 0 ? 0 : 2 }).format(c);
  }
  function counts(n) { doc.querySelectorAll("[data-apc-count]").forEach(function (e) { e.textContent = n ? String(n) : ""; }); }

  var drawer = doc.querySelector("[data-apc]");
  var itemsEl = drawer && drawer.querySelector("[data-apc-items]");
  var emptyEl = drawer && drawer.querySelector("[data-apc-empty]");
  var footEl = drawer && drawer.querySelector("[data-apc-foot]");
  var subEl = drawer && drawer.querySelector("[data-apc-subtotal]");

  function openDrawer() { if (!drawer) return; drawer.classList.add("is-open"); drawer.setAttribute("aria-hidden", "false"); doc.body.classList.add("apc-open"); }
  function closeDrawer() { if (!drawer) return; drawer.classList.remove("is-open"); drawer.setAttribute("aria-hidden", "true"); doc.body.classList.remove("apc-open"); }

  function render(cart) {
    if (!drawer) return;
    counts(cart.item_count);
    if (!cart.items || !cart.items.length) { if (itemsEl) itemsEl.innerHTML = ""; if (emptyEl) emptyEl.hidden = false; if (footEl) footEl.hidden = true; return; }
    if (emptyEl) emptyEl.hidden = true; if (footEl) footEl.hidden = false;
    itemsEl.innerHTML = cart.items.map(function (it) {
      var img = it.image ? it.image.replace(/(\.(?:jpg|jpeg|png|webp|gif))(\?|$)/i, "_240x$1$2") : "";
      var vt = it.variant_title && it.variant_title !== "Default Title" ? it.variant_title : "";
      return '<li class="apc__item" data-key="' + it.key + '">' +
        '<a class="apc__thumb2" href="' + it.url + '">' + (img ? '<img src="' + img + '" alt="" loading="lazy" decoding="async">' : "") + "</a>" +
        '<div class="apc__info2">' +
        '<a class="apc__name" href="' + it.url + '">' + it.product_title + "</a>" +
        (vt ? '<div class="apc__variant">' + vt + "</div>" : "") +
        '<div class="apc__line-bottom">' +
        '<div class="apc__stepper"><button type="button" data-apc-dec aria-label="Decrease">&minus;</button><span data-apc-q>' + it.quantity + "</span><button type=\"button\" data-apc-inc aria-label=\"Increase\">&plus;</button></div>" +
        '<span class="apc__price2">' + money(it.final_line_price) + "</span>" +
        "</div>" +
        '<button class="apc__remove" type="button" data-apc-remove>Remove</button>' +
        "</div></li>";
    }).join("");
    if (subEl) subEl.textContent = money(cart.total_price);
  }

  function getCart() { return fetch("/cart.js", { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); }); }
  function refresh() { return getCart().then(render); }
  function addItem(id, qty) {
    return fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ id: id, quantity: qty || 1 }) })
      .then(function (r) { if (!r.ok) return r.json().then(function (e) { throw e; }); return r.json(); });
  }
  function changeLine(key, qty) {
    return fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (r) { return r.json(); }).then(render);
  }

  if (drawer) {
    drawer.addEventListener("click", function (e) {
      if (e.target.closest("[data-apc-close]")) { closeDrawer(); return; }
      var li = e.target.closest(".apc__item"); if (!li) return;
      var key = li.getAttribute("data-key");
      var q = parseInt(li.querySelector("[data-apc-q]").textContent, 10) || 1;
      if (e.target.closest("[data-apc-inc]")) changeLine(key, q + 1);
      else if (e.target.closest("[data-apc-dec]")) changeLine(key, q - 1);
      else if (e.target.closest("[data-apc-remove]")) changeLine(key, 0);
    });
    doc.addEventListener("keydown", function (e) { if (e.key === "Escape") closeDrawer(); });
    refresh();
  }
  doc.addEventListener("click", function (e) { if (e.target.closest("[data-apc-open]")) { e.preventDefault(); openDrawer(); } });

  /* ---- product page ---- */
  var apr = doc.querySelector("[data-apr]");
  if (apr) {
    var slides = apr.querySelectorAll("[data-apr-slide]");
    var thumbs = apr.querySelectorAll("[data-apr-thumb]");
    function show(i) {
      slides.forEach(function (s) { s.classList.toggle("is-active", s.getAttribute("data-index") === String(i)); });
      thumbs.forEach(function (t) { t.classList.toggle("is-active", t.getAttribute("data-index") === String(i)); });
    }
    thumbs.forEach(function (t) { t.addEventListener("click", function () { show(t.getAttribute("data-index")); }); });

    var variants = [];
    try { variants = JSON.parse(apr.querySelector("[data-apr-variants]").textContent); } catch (e) {}
    var idInput = apr.querySelector("[data-apr-variant-id]");
    var priceEl = apr.querySelector("[data-apr-price]");
    var atc = apr.querySelector("[data-apr-atc]");
    var atcText = apr.querySelector("[data-apr-atc-text]");
    var acquired = apr.querySelector("[data-apr-acquired]");
    var qtyBox = apr.querySelector("[data-apr-qty]");

    function chosenVariant() {
      if (!variants.length) return null;
      var picked = [];
      apr.querySelectorAll("[data-apr-opt]:checked").forEach(function (inp) { picked[parseInt(inp.getAttribute("data-position"), 10) - 1] = inp.value; });
      if (!picked.length) return variants[0];
      var found = null;
      variants.forEach(function (v) { if (!found && v.options.length === picked.length && v.options.every(function (o, i) { return o === picked[i]; })) found = v; });
      return found;
    }
    function updateVariant() {
      var v = chosenVariant(); if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      apr.querySelectorAll(".apr__swatch").forEach(function (l) { var inp = l.querySelector("input"); l.classList.toggle("is-selected", !!(inp && inp.checked)); });
      // sold variant → no buy button, no quantity, just the inert "Acquired" label
      if (v.available) {
        atc.removeAttribute("disabled"); atc.hidden = false;
        if (atcText) atcText.textContent = atc.getAttribute("data-atc-label") || "Acquire";
        if (qtyBox) qtyBox.hidden = false;
        if (acquired) acquired.hidden = true;
      } else {
        atc.hidden = true;
        if (qtyBox) qtyBox.hidden = true;
        if (acquired) acquired.hidden = false;
      }
      if (v.id && history.replaceState) { try { var u = new URL(location.href); u.searchParams.set("variant", v.id); history.replaceState({}, "", u); } catch (e) {} }
    }
    apr.querySelectorAll("[data-apr-opt]").forEach(function (inp) { inp.addEventListener("change", updateVariant); });

    var qtyInput = apr.querySelector("[data-apr-qty-input]");
    var minus = apr.querySelector("[data-apr-minus]"), plus = apr.querySelector("[data-apr-plus]");
    if (minus) minus.addEventListener("click", function () { qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1); });
    if (plus) plus.addEventListener("click", function () { qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + 1); });
    if (qtyInput) qtyInput.addEventListener("input", function () { qtyInput.value = qtyInput.value.replace(/[^0-9]/g, "") || 1; });

    var form = apr.querySelector(".apr__form");
    if (form) form.addEventListener("submit", function (e) {
      e.preventDefault();
      var v = chosenVariant();
      if (v && !v.available) return; // sold piece: nothing to add, and never redirect to an inquiry page
      var id = idInput ? idInput.value : (v && v.id);
      var qty = parseInt(qtyInput ? qtyInput.value : 1, 10) || 1;
      if (!id) return;
      atc.classList.add("is-loading");
      addItem(id, qty).then(refresh).then(function () { atc.classList.remove("is-loading"); openDrawer(); })
        .catch(function () { atc.classList.remove("is-loading"); if (atcText) atcText.textContent = "Try again"; });
    });
    updateVariant();
  }
})();
